import { render, staticRenderFns } from "./addKeepRecord.vue?vue&type=template&id=295b7386&"
import script from "./addKeepRecord.vue?vue&type=script&lang=js&"
export * from "./addKeepRecord.vue?vue&type=script&lang=js&"
import style0 from "./addKeepRecord.vue?vue&type=style&index=0&id=295b7386&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports